var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner slide",class:{'your-turn': _vm.isMyTurn }},[(_vm.isMyTurn)?[_vm._v(" Your Turn ")]:[_vm._v(" "+_vm._s(_vm.player.name)+"'s turn ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }